module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk med tjenesteløfte_sekundærlogo_neg(hvit).66bd1b15.pdf";